/**
 * @generated SignedSource<<8229e5fd7c776cfe8cb7f2e5471d04f0>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type identityprovidertype = "AXON" | "OIDC" | "SAML" | "UNKNOWN" | "%future added value";
export type login_type = "AXON" | "ONE_TIME_PASSWORD" | "SSO" | "UNKNOWN" | "%future added value";
export type organizationpermission = "ADMIN" | "MEMBER" | "MODERATOR" | "REMOTE_PILOT" | "SKYDIO_READONLY" | "SKYDIO_SUPERUSER" | "TESTER" | "UNKNOWN" | "%future added value";
export type resource_group_permission = "ADMIN" | "MEMBER" | "MODERATOR" | "REMOTE_PILOT" | "SKYDIO_READONLY" | "SKYDIO_SUPERUSER" | "TESTER" | "UNKNOWN" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type UserProfile_loginTypes$data = {
  readonly email: string;
  readonly expiry: string | null;
  readonly firstName: string | null;
  readonly id: string;
  readonly lastName: string | null;
  readonly loginTypes: {
    readonly __id: string;
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly authEnabled: boolean;
        readonly identityProviderConfiguration: {
          readonly id: string;
          readonly name: string;
          readonly providerType: identityprovidertype;
          readonly uuid: string;
        } | null;
        readonly loginType: login_type;
      } | null;
    } | null>;
  } | null;
  readonly loginTypesOverriden: boolean | null;
  readonly organizationNotes: string | null;
  readonly organizationPermission: organizationpermission;
  readonly phoneNumber: string | null;
  readonly resourceGroupLinks: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly resourceGroupId: string;
        readonly resourceGroupName: string | null;
        readonly resourceGroupPermission: resource_group_permission;
      } | null;
    } | null>;
  } | null;
  readonly uuid: string;
  readonly " $fragmentType": "UserProfile_loginTypes";
};
export type UserProfile_loginTypes$key = {
  readonly " $data"?: UserProfile_loginTypes$data;
  readonly " $fragmentSpreads": FragmentRefs<"UserProfile_loginTypes">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "uuid",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "UserProfile_loginTypes",
  "selections": [
    (v0/*: any*/),
    (v1/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "email",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "firstName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "lastName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "organizationPermission",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "loginTypesOverriden",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "phoneNumber",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "expiry",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "organizationNotes",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "UserResourceGroupLinkConnection",
      "kind": "LinkedField",
      "name": "resourceGroupLinks",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "UserResourceGroupLinkEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "UserResourceGroupLink",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "resourceGroupId",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "resourceGroupName",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "resourceGroupPermission",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "LoginTypesConnection",
      "kind": "LinkedField",
      "name": "loginTypes",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "LoginTypesEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "LoginTypes",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "loginType",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "authEnabled",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "IdentityProviderConfiguration",
                  "kind": "LinkedField",
                  "name": "identityProviderConfiguration",
                  "plural": false,
                  "selections": [
                    (v0/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "name",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "providerType",
                      "storageKey": null
                    },
                    (v1/*: any*/)
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "kind": "ClientExtension",
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "__id",
              "storageKey": null
            }
          ]
        }
      ],
      "storageKey": null
    }
  ],
  "type": "User",
  "abstractKey": null
};
})();

(node as any).hash = "8c60bdf6abd8a70db5baa635684eb101";

export default node;
